import http from "./client";
import ICurator from "../typings/ICurator";
import { IGetStudentsQueryParams } from "./students";
import { IStudentSortListFilter } from "../typings/ISortList";

export interface ICuratorsListQueryParams {
  id?: number | string; // Нужно временно для возможности получить данные только по одному наставнику
  
  search?: string;
  page?: number;
  limit?: number;
  course_id?: number | string;
  group_id?: number | string;
  withStudentsCount?: boolean;
  withHomeworksCount?: boolean;
  status?: 'active' | 'all' | 'deleted',
  sort?: {
    sortBy?: 'curator' | 'lastActivity' | 'students',
    order?: 'asc' | 'desc';
  }
}

interface ICuratorsResponse {
  success: boolean;
  errorMessage?: string;
  paginator?: {
    limit: number;
    page: number;
    pageCount: number;
    totalItemCount: number;
  },
  metaData?: any;
  data?: Array<ICurator>;
}

async function update (curator: ICurator) {
  const response = await http.post('/api/curator/save', curator);
  return response.data;
}

async function remove(curatorId: number, courseId: number | string, notify: boolean) {
  const response = await http.post('/api/curator/remove', {
    curator_id: curatorId,
    course_id: courseId,
    notify // уведомить куратора об удалении из курса
  });
  return response.data;
}

async function restore(curatorId: number, courseId: number | string) {
  const response = await http.post('/api/curator/restore', {
    curator_id: curatorId,
    course_id: courseId
  });
  return response.data;
}


async function add(person:Array<{email:string, name:string,surname:string, phone:string}>,courseId: number | string, file?: string) {
  const response = await http.post('/api/curator/add', {
    person,
    file,
    course_id: courseId
  });
  return response.data;
}



async function byId(id: number | string, courseId: number | string) {
  const response = await http.get<ICuratorsResponse>('/api/curator/list', {
    params: {
      course_id: courseId,
      id
    }
  });
  return response.data;

}

async function list (queryParams: ICuratorsListQueryParams) {
  const response = await http.get<ICuratorsResponse>('/api/curator/list', {
    params: queryParams
  });
  return response.data;
}

async function authors (): Promise<Array<ICurator>> {
  const response = await http.get<ICuratorsResponse>('/api/curator/authors');
  if (!response.data.data) return [];
  return response.data.data;
}

async function link(courseId: number | string, users: Array<number | string>, curatorId: number | string) {
  const response = await http.post('/api/curator/link', {
    course_id: courseId,
    users,
    curatorId,
  });
  return response.data;
}

async function unlink(courseId: number | string, users: Array<number | string>, curatorId: number | string) {
  const response = await http.post('/api/curator/unlink', {
    course_id: courseId,
    users,
    curatorId
  });
  return response.data;
}

async function linkAll(courseId: number | string, sortParams?: IGetStudentsQueryParams, curatorId?: number | string) {
  const response = await http.post('/api/curator/link-all', {
    course_id: courseId,
    curatorId,
    filter: sortParams,
  });
  return response.data;
}

async function unlinkAll(courseId: number | string, curatorId: number | string, filter?: IStudentSortListFilter) {
  const response = await http.post('/api/curator/unlink-all', {
    course_id: courseId,
    curatorId,
    filter: filter,
  });
  return response.data;
}

const curators = {
  update,
  byId,
  list,
  add,
  remove,
  restore,
  authors,
  link,
  unlink,
  linkAll,
  unlinkAll
}

export default curators;